<script>
import Vue from 'vue';
import {mapState, mapActions, mapGetters} from 'vuex';
import {getContractManagementPartLink} from "../../services/ConverterService";

export default Vue.extend({
    data() {
        return {
            toggled: true
        }
    },
    computed: {
        ...mapState({
            basic: state => state.contract.contractManagement.progress.basic,
            extended: state => state.contract.contractManagement.progress.extended,
            done: state => state.contract.contractManagement.progress.done,
            part: state => state.contract.contractManagement.from.part,
            subPart: state => state.contract.contractManagement.form.subPart
        }),
        ...mapGetters({
            calculateContractManagementProgress: 'contract/calculateContractManagementProgress',
            contractManagementProgressObject: 'contract/contractManagementProgressObject'
        })
    },
    methods: {
        ...mapActions({
            setContractManagementFormPart: 'contract/setContractManagementFormPart',
            contractManagementSetNoChanges: 'contract/contractManagementSetNoChanges'
        }),
        getContractManagementPartLink(subPart) {
            return getContractManagementPartLink(subPart);
        },
        noChanges(obj) {
            // All parts except sites and accommodations will have this feature
            if (obj.subPart !== 'siteInfo' && obj.subPart !== 'accInfo' && obj.subPart !== 'brands') {
                // Display alert before inserting 'No changes'
                if (confirm(this.$t('contractManagement.noChangesConfirm'))) {
                    this.contractManagementSetNoChanges(obj);
                }
            }
        }
    }
});
</script>
<template>
    <div class="contract-management-edit-progress">
        <div class="contract-management-edit-progress__header" @click="toggled = !toggled">
            <div :class="{'contract-management-edit-progress__heading--toggled': toggled}" class="contract-management-edit-progress__heading">
                {{ $t('contractManagement.edit.progress.header.heading') }} > {{ calculateContractManagementProgress }} %
            </div>
        </div>
        <transition name="fade" type="in-out">
            <div v-if="toggled" class="contract-management-edit-progress__content">
                <div class="contract-management-edit-progress__items">
                    <div class="contract-management-edit-progress__item">
                        <div class="contract-management-edit-progress__item-label">{{ $t('contractManagement.edit.progress.basic') }}</div>
                        <div class="contract-management-edit-progress__item-elements">
                            <div v-for="(item, index) in basic"
                                 :key="index"
                                 class="contract-management-edit-progress__item-element contract-management-edit-progress__item-element--basic"
                                 @dblclick="noChanges({part: 'basic', subPart: index, text: $t('contractManagement.edit.progress.defaultText')})"
                                 @click="setContractManagementFormPart({part: 'basic', subPart: index})">
                                <div class="contract-management-edit-progress__item-sub-header">
                                    <span v-if="index !== 'priceExtra' && index !== 'notes'">
                                        <a :href="getContractManagementPartLink(index)" class="contract-management-edit-progress__link" target="_blank">
                                            {{ $t('contractManagement.edit.progress.subHeader.' + index) }}
                                        </a>
                                    </span>
                                    <span v-if="index === 'priceExtra'">
                                        <a :href="getContractManagementPartLink(index)[0]" class="contract-management-edit-progress__link" target="_blank">
                                            {{ $t('contractManagement.edit.progress.subHeader.' + index + '.price') }}
                                        </a>
                                        <span>/</span>
                                        <a :href="getContractManagementPartLink(index)[1]" class="contract-management-edit-progress__link" target="_blank">
                                            {{ $t('contractManagement.edit.progress.subHeader.' + index + '.extra') }}
                                        </a>
                                    </span>
                                    <span v-if="index === 'notes'">
                                        {{ $t('contractManagement.edit.progress.subHeader.' + index) }}
                                    </span>
                                </div>
                                <div :class="[
                                         {'contract-management-edit-progress__item-icon--done': item},
                                         {'contract-management-edit-progress__item-icon--active': subPart === index},
                                         {'contract-management-edit-progress__item-icon--optional': index === 'notes'}
                                     ]"
                                     class="contract-management-edit-progress__item-icon">
                                    <span v-if="item"><i class="fa fa-check-square"/></span>
                                    <span v-if="!item"><i class="fa fa-minus-square"/></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="contract-management-edit-progress__item">
                        <div class="contract-management-edit-progress__item-label">{{ $t('contractManagement.edit.progress.extended') }}</div>
                        <div class="contract-management-edit-progress__item-elements">
                            <div v-for="(item, index) in extended"
                                 :key="index"
                                 class="contract-management-edit-progress__item-element contract-management-edit-progress__item-element--extended"
                                 @dblclick="noChanges({part: 'extended', subPart: index, text: $t('contractManagement.edit.progress.defaultText')})"
                                 @click="setContractManagementFormPart({part: 'extended', subPart: index})">
                                <div class="contract-management-edit-progress__item-sub-header">
                                    <a :href="getContractManagementPartLink(index)" class="contract-management-edit-progress__link" target="_blank">
                                        {{ $t('contractManagement.edit.progress.subHeader.' + index) }}
                                    </a>
                                </div>
                                <div :class="[
                                         {'contract-management-edit-progress__item-icon--done': item},
                                         {'contract-management-edit-progress__item-icon--active': subPart === index},
                                         {'contract-management-edit-progress__item-icon--optional': index === 'notes'},
                                     ]"
                                     class="contract-management-edit-progress__item-icon">
                                    <span v-if="item"><i class="fa fa-check-square"/></span>
                                    <span v-if="!item"><i class="fa fa-minus-square"/></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ContractManagementEditProgress/ContractManagementEditProgress.vue